/*
* Кеширующая обёртка
* */
export function caching(fn) {
    if (typeof fn !== 'function')
        throw new TypeError('Parameter is not a function');

    let cache;

    return () => {
        if (cache === undefined)
            cache = fn();

        return cache;
    };
}
